import { render, staticRenderFns } from "./Fps_approve.vue?vue&type=template&id=2d6f06de"
import script from "./Fps_approve.vue?vue&type=script&setup=true&lang=js"
export * from "./Fps_approve.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Fps_approve.vue?vue&type=style&index=0&id=2d6f06de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports